import PropTypes from 'prop-types'
import { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Container, Row, Col, Input } from 'reactstrap'
import { isValidEmail } from '../../util/utils'

const PunchoutEmailInput = ({ value, onChange }) => {
  const session = useSelector(state => state.session)
  const currentLocation = useSelector(state => state.storeViews.current)
  const show = !!session?.punchout_buyer && !!currentLocation?.punchout_collect_email

  const [touched, setTouched] = useState(false)
  const emailValid = isValidEmail(value || '')

  const handleEmailChange = useCallback(
    e => {
      const newEmail = e.target.value
      setTouched(true)
      onChange?.(newEmail)
    },
    [onChange]
  )

  if (!show) {
    return null
  }

  return (
    <div className="box-shadow white-background m-0">
      <div className="ckout-header">
        <h5 className="m-0">Punchout Contact</h5>
      </div>
      <Container className="mb-4">
        <Row className="align-items-start p-3">
          <Col xs="12">
            <p className="mb-2">Provide an email address for this purchase request.</p>
            <Input
              placeholder="Contact Email"
              name="punchout_contact_email"
              type="email"
              value={value || ''}
              onChange={handleEmailChange}
              className={!emailValid && touched ? 'is-invalid' : ''}
              autoComplete="email"
            />
            {!emailValid && touched && <div className="text-danger small mt-1">Please enter a valid email.</div>}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PunchoutEmailInput

PunchoutEmailInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}
